import { PermissionEnum } from "../../misc/api/ApiPermissionEnum";
import { Permission } from "../../misc/api/apiTypes";

export interface HistoryFromState {
    from: string;
}

export const GoBackToList = (history, currentUserPermissions: Permission[], sessionListRoute: string, analysisPermission: PermissionEnum, analysisListRoute: string) => {
    if (history.location.state?.from) {
        history.push(history.location.state.from.replace("/spa", ""));
        return;
    }

    currentUserPermissions.map(p => p.Id).includes(analysisPermission) ? history.push(analysisListRoute) : history.push(sessionListRoute);

}
